// TZ Database time zone identifiers
// based on https://en.wikipedia.org/wiki/List_of_tz_database_time_zones - for now all none america timezones filtered out
// For the record - Adam thought that we should support the daylight by ourselfs to not count on other libs.
export const TimezoneIdentifiers = [
    // Africa
    // 'Africa/Abidjan',
    // 'Africa/Algiers',
    // 'Africa/Cairo',
    // 'Africa/Casablanca',
    // 'Africa/Johannesburg',
    // 'Africa/Lagos',
    // 'Africa/Nairobi',
    // 'Africa/Tunis',
    // America
    'America/Anchorage',
    'America/Argentina/Buenos_Aires',
    'America/Bogota',
    'America/Caracas',
    'America/Chicago',
    'America/Denver',
    'America/Detroit',
    'America/Halifax',
    'America/Havana',
    'America/Lima',
    'America/Los_Angeles',
    'America/Mexico_City',
    'America/New_York',
    'America/Phoenix',
    'America/Santiago',
    'America/Sao_Paulo',
    'America/St_Johns',
    'America/Toronto',
    'America/Vancouver',
    // Asia
    // 'Asia/Baghdad',
    // 'Asia/Bangkok',
    // 'Asia/Beirut',
    // 'Asia/Colombo',
    // 'Asia/Damascus',
    // 'Asia/Dhaka',
    // 'Asia/Dubai',
    // 'Asia/Ho_Chi_Minh',
    // 'Asia/Hong_Kong',
    // 'Asia/Istanbul',
    // 'Asia/Jakarta',
    'Asia/Jerusalem',
    // 'Asia/Kabul',
    // 'Asia/Karachi',
    // 'Asia/Kathmandu',
    // 'Asia/Kolkata',
    // 'Asia/Kuala_Lumpur',
    // 'Asia/Kuwait',
    // 'Asia/Manila',
    // 'Asia/Riyadh',
    // 'Asia/Seoul',
    // 'Asia/Shanghai',
    // 'Asia/Singapore',
    // 'Asia/Taipei',
    // 'Asia/Tehran',
    // 'Asia/Tokyo',
    // Atlantic
    // 'Atlantic/Azores',
    // 'Atlantic/Canary',
    // 'Atlantic/Reykjavik',
    // Australia
    // 'Australia/Adelaide',
    // 'Australia/Brisbane',
    // 'Australia/Darwin',
    // 'Australia/Hobart',
    // 'Australia/Melbourne',
    // 'Australia/Perth',
    // 'Australia/Sydney',
    // Europe
    // 'Europe/Amsterdam',
    // 'Europe/Athens',
    // 'Europe/Belgrade',
    // 'Europe/Berlin',
    // 'Europe/Brussels',
    // 'Europe/Bucharest',
    // 'Europe/Budapest',
    // 'Europe/Copenhagen',
    // 'Europe/Dublin',
    // 'Europe/Helsinki',
    // 'Europe/Kyiv',
    // 'Europe/Lisbon',
    // 'Europe/London',
    // 'Europe/Madrid',
    // 'Europe/Moscow',
    // 'Europe/Oslo',
    // 'Europe/Paris',
    // 'Europe/Prague',
    // 'Europe/Rome',
    // 'Europe/Sofia',
    // 'Europe/Stockholm',
    // 'Europe/Vienna',
    // 'Europe/Warsaw',
    // 'Europe/Zurich',
    // Indian
    // 'Indian/Maldives',
    // 'Indian/Mauritius',
    // Pacific
    // 'Pacific/Auckland',
    // 'Pacific/Fiji',
    // 'Pacific/Guam',
    // 'Pacific/Honolulu',
    // 'Pacific/Tahiti',
    // UTC
    // 'UTC',
];
//# sourceMappingURL=consts.js.map